import { useState } from 'react'

/**
 * ExperimentalWrapper
 *
 * Bordo dorato animato con scritta "FUNZIONE SPERIMENTALE".
 * Gradiente oro shimmer + glow pulsante, NO stelle/particelle.
 * Si attiva solo se isExperimental === true.
 */
export default function ExperimentalWrapper({ isExperimental, children }) {
  const [dismissed, setDismissed] = useState(false)

  if (!isExperimental) return children

  return (
    <div className="experimental-wrapper relative">
      <style>{`
        .experimental-wrapper {
          --gold-1: #c9a13b;
          --gold-2: #f0d060;
          --gold-3: #e8b923;
          position: relative;
          border-radius: 12px;
          padding: 3.5px;
          background:
            linear-gradient(
              135deg,
              var(--gold-1) 0%,
              var(--gold-2) 25%,
              var(--gold-3) 50%,
              var(--gold-2) 75%,
              var(--gold-1) 100%
            );
          background-size: 300% 300%;
          animation: shimmer 4s ease-in-out infinite;
          box-shadow:
            0 0 10px rgba(201, 161, 59, 0.35),
            0 0 24px rgba(201, 161, 59, 0.18);
        }

        .experimental-wrapper::before {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 12px;
          box-shadow: 0 0 20px rgba(240, 208, 96, 0.45);
          animation: glow 3s ease-in-out infinite;
          pointer-events: none;
        }

        @keyframes shimmer {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        @keyframes glow {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>

      <div className="bg-white dark:bg-gray-800 rounded-[10px] relative">
        {/* Badge sperimentale */}
        {!dismissed && (
          <div className="relative flex items-center justify-center px-4 py-2 bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-yellow-900/20 rounded-t-[10px] border-b border-amber-200/50 dark:border-amber-700/30">
            <span className="text-xs font-semibold tracking-wider uppercase"
              style={{
                background: 'linear-gradient(135deg, #b8860b, #daa520, #b8860b)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}
            >
              Funzione sperimentale
            </span>
            <button
              onClick={() => setDismissed(true)}
              className="absolute right-3 text-amber-400 hover:text-amber-600 text-xs"
              title="Nascondi"
            >
              &times;
            </button>
          </div>
        )}

        {children}
      </div>
    </div>
  )
}
